module.exports = __webpack_public_path__ + "static/maintanance-d87a5d8b8060c1c09c0b035fa8d5b905.svg";